'use strict';

module.exports = ['$scope', '$rootScope', '$controller', '$location', '$window', 'ProductionScheduleSvc', 'ProductionModeSvc', function ($scope, $rootScope, $controller, $location, $window, ProductionScheduleSvc, ProductionModeSvc) {
    $controller('PDCalendarCtrl', {$scope: $scope});

    // ------------------
    // Scope Functions
    // ------------------
    $scope.getHeight = function (entry) {
        // include production rate?
        var rawValue = entry.hours_per_day * entry.production_rate;
        var productionMode = $scope.production_modes_by_id[entry.production_mode];
        var default_hours_per_day = 8;
        var averageRate = default_hours_per_day * productionMode.default_hourly_rate;
        var adjustedValue = rawValue / averageRate;
        var cellHeight = 25;
        return cellHeight * adjustedValue + 'px';
    };

    $scope.getColor = function (entry) {
        return ProductionModeSvc.getColor(entry.production_mode, $scope.plant);
    };

    // ------------------
    // EVENTS
    // ------------------
    $scope.$on('entryUpdated', function () {
        $scope.loadMonth($scope.selectedYear, $scope.selectedMonth);
    });

    ProductionModeSvc.loadAll($rootScope.plant).success(function (data) {
        $scope.production_modes = data;
        $scope.production_modes_by_id = ProductionModeSvc.listToIdMap(data);

        $scope.currentMonthClick();
    });

    // ------------------
    // Initialization
    // ------------------
    $scope.dataSvc = ProductionScheduleSvc;
    $scope.calendar = {};
    $scope.calendar.detailMode = false;
    $scope.production_modes = [];
    $scope.production_modes_by_id = [];
}];